import React from 'react';
import clsx from 'clsx';
import { XOverlay } from '../overlay/XOverlay';
import { XCard } from '../card/XCard';
import { preventClick } from '../../../util/preventClick';
import { XBox } from '../box/XBox';
export var XDialogSize;
(function (XDialogSize) {
    XDialogSize["SMALL"] = "small";
    XDialogSize["DEFAULT"] = "default";
})(XDialogSize || (XDialogSize = {}));
export function XDialog(_a) {
    var header = _a.header, children = _a.children, footer = _a.footer, size = _a.size, onClose = _a.onClose, className = _a.className, transparent = _a.transparent, overlayClass = _a.overlayClass;
    var ContentContainer = transparent ? XBox : XCard;
    return (React.createElement(XOverlay, { onClose: onClose, className: overlayClass },
        React.createElement("div", { className: clsx(className, "XDialog size-" + (size || ''), { transparent: transparent }) },
            React.createElement(ContentContainer, { className: 'content-container', onClick: preventClick },
                header && React.createElement("div", { className: 'dialog-header' }, header),
                React.createElement("div", { className: 'dialog-content-container' }, children),
                footer && React.createElement("div", { className: 'dialog-footer' }, footer)))));
}
